export default __webpack_public_path__ + "static/media/hht1_song_17.7ff2cd2e.png";